/**
 * Computes the norm of the given values
 * @param {Array<number>} input
 * @param {object} [options={}]
 * @param {string} [algorithm='absolute']
 * @return {number}
 */
function norm(input) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$algorithm = options.algorithm,
      algorithm = _options$algorithm === void 0 ? 'absolute' : _options$algorithm;

  if (!Array.isArray(input)) {
    throw new Error('input must be an array');
  }

  if (input.length === 0) {
    throw new Error('input must not be empty');
  }

  switch (algorithm.toLowerCase()) {
    case 'absolute':
      var sum = absoluteSum(input);
      if (sum === 0) return input.slice(0);
      return input.map(function (element) {
        return element / sum;
      });

    default:
      throw new Error("norm: unknown algorithm: ".concat(algorithm));
  }
}

function absoluteSum(input) {
  var sum = 0;

  for (var i = 0; i < input.length; i++) {
    sum += Math.abs(input[i]);
  }

  return sum;
}

export default norm;
